import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import short from "../../../assets/icons/short.png";
import medium from "../../../assets/icons/medium.png";
import long from "../../../assets/icons/long.png";

const cardStyle = {
  bgcolor: "#fff",
  color: "#000",
};

const objectList = [
  {
    icon: short,
    title: "Short-Term (Year 1-2)",
    subtitle:
      "The AIR Fund strengthens early-stage innovators in climate action, artificial intelligence, secondary cities, and social innovation by providing grants and non-grant support, such as access to networks, strategic guidance, and resources. Our grants will support the launch of pilot programs that address specific community challenges, including building resilience in secondary cities, developing AI solutions for societal impact, and advancing local climate adaptation initiatives. The fund measures success by tracking the number of pilots launched, innovators supported, and levels of community participation and engagement achieved.",
  },
  {
    icon: medium,
    title: "Medium-Term (Year 3-4)",
    subtitle:
      "AIR Fund scales successful projects and replicates effective models across multiple regions, achieving measurable results in climate resilience, digital equity, and social innovation. It expands initiatives that enhance urban sustainability in secondary cities, implements AI-driven tools to improve governance and public services, and reduces climate-related vulnerabilities in targeted communities. Progress metrics include the adoption of innovative solutions, increased access to sustainable services, and strengthened collaboration among innovators and communities.",
  },
  {
    icon: long,
    title: "Long-Term (Year 5 and beyond)",
    subtitle:
      "The AIR Fund establishes resilient, self-sustaining ecosystems across Africa by supporting the growth of independent innovation hubs, fostering solutions for climate adaptation, and driving AI and social innovation in localized contexts. It enables underrepresented groups to lead transformative efforts while maintaining progress without external dependence. Success is defined by reduced climate vulnerabilities, improved urban resilience in secondary cities, and ongoing empowerment of marginalized populations to sustain innovation and equity.",
  },
];

const Outcome = () => {
  return (
    <Box margin={{ xs: "35% 0% 30% 0%", sm: "10% 0% 10% 0%" }}>
      <Typography
        variant="h3"
        fontWeight={700}
        textAlign={"left"}
        paddingBottom={{ xs: "4%", sm: "2%" }}
        color={"#39484E"}
      >
        Outcome Pathways
      </Typography>
      <Grid container spacing={1}>
        {objectList.map((list, index) => {
          const { title, icon, subtitle } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                margin={{ xs: "5% 0%", sm: "0%" }}
              >
                <Box
                  key={index}
                  component={Card}
                  height={"100%"}
                  padding={{ xs: "4% 4%", sm: "8% 8% 4% 8%" }}
                  margin={{ xs: "2% 0%", sm: "4% 0%" }}
                  borderRadius={"20px"}
                  display={"flex"}
                  flexDirection={"column"}
                  width={{ xs: "100%", sm: "100%" }}
                  sx={{ ...cardStyle }}
                >
                  <Box marginLeft={"2%"}>
                    {" "}
                    <Box
                      component="img"
                      height={{ xs: "64px", sm: "64px" }}
                      sx={{
                        objectFit: "cover",
                        overflow: "hidden",
                        width: "100%",
                      }}
                      src={icon}
                      alt={"icons"}
                    />
                  </Box>
                  <Typography
                    variant={"h5"}
                    fontWeight={700}
                    paddingTop={"6%"}
                    color={"#39484E"}
                  >
                    {title}
                  </Typography>
                  <Typography
                    variant={"body1"}
                    paddingTop={"6%"}
                    color={"#000"}
                  >
                    {subtitle}
                  </Typography>
                </Box>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Outcome;
